import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "yesBlank" })
export class yesBlankPipe implements PipeTransform {
    transform(value: boolean, field: string): string {
    
        return value ? 'Yes' : '';
    }
}
